export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  const style = `<style>
  </style>`;
  bm.add('filet', {
    label: 'filet',
    title: 'filet',
    category: 'Widget',
    content: `
        <span data-gjs-type="filet"  style="z-index: 5;
            position: absolute;
            left: 50%;
            width: 3pt;
            height:3em;
            background-color: #E42313;">  
        </span>
        ${style}
      `,
    attributes: {
      class: 'icon-separator', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/filet/blocks.js